// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Milestone documents tab + document cards. Scoped under .milestone-docs / .milestone-doc. */

.milestone-docs {
  min-width: 0;
  padding: var(--ds-space-3);
  background: var(--ds-surface);
  border: 1px solid var(--ds-border-soft);
  border-radius: var(--ds-radius-lg);
}

.milestone-docs .milestone-docs__preview {
  display: flex;
  justify-content: center;
  margin-bottom: var(--ds-space-3);
  max-width: 100%;
  overflow: hidden;
}

/* Upload row: file picker, title and button share a row on wide screens, stack on phones. */
.milestone-docs .milestone-docs__composer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--ds-space-2);
}

.milestone-docs .milestone-docs__title-input {
  flex: 1 1 220px;
  min-width: 0;
}

.milestone-docs .milestone-docs__list {
  margin-top: var(--ds-space-5);
}

.milestone-docs .milestone-docs__pagination {
  display: flex;
  justify-content: center;
  margin-top: var(--ds-space-5);
}

.milestone-doc .milestone-doc__toolbar {
  display: flex;
  justify-content: flex-end;
}

.milestone-doc .milestone-doc__file {
  max-height: 400px;
  max-width: 100%;
  margin-top: var(--ds-space-3);
  overflow: hidden;
  text-align: center;
}

.milestone-doc .milestone-doc__file img,
.milestone-doc .milestone-doc__file video,
.milestone-doc .milestone-doc__file iframe {
  max-width: 100%;
}

.milestone-doc .milestone-doc__message {
  margin: var(--ds-space-2) 0;
  overflow-wrap: anywhere;
}

.milestone-doc .milestone-doc__comment {
  width: 100%;
  margin-top: var(--ds-space-4);
}

@media (max-width: 575.98px) {
  .milestone-docs .milestone-docs__composer > .ant-btn {
    flex: 1 1 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/commons/Projects/Milestones/MilestoneDocuments/MilestoneDocuments.css"],"names":[],"mappings":"AAAA,6FAA6F;;AAE7F;EACE,YAAY;EACZ,0BAA0B;EAC1B,6BAA6B;EAC7B,uCAAuC;EACvC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA,4FAA4F;AAC5F;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE;IACE,cAAc;EAChB;AACF","sourcesContent":["/* Milestone documents tab + document cards. Scoped under .milestone-docs / .milestone-doc. */\n\n.milestone-docs {\n  min-width: 0;\n  padding: var(--ds-space-3);\n  background: var(--ds-surface);\n  border: 1px solid var(--ds-border-soft);\n  border-radius: var(--ds-radius-lg);\n}\n\n.milestone-docs .milestone-docs__preview {\n  display: flex;\n  justify-content: center;\n  margin-bottom: var(--ds-space-3);\n  max-width: 100%;\n  overflow: hidden;\n}\n\n/* Upload row: file picker, title and button share a row on wide screens, stack on phones. */\n.milestone-docs .milestone-docs__composer {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: var(--ds-space-2);\n}\n\n.milestone-docs .milestone-docs__title-input {\n  flex: 1 1 220px;\n  min-width: 0;\n}\n\n.milestone-docs .milestone-docs__list {\n  margin-top: var(--ds-space-5);\n}\n\n.milestone-docs .milestone-docs__pagination {\n  display: flex;\n  justify-content: center;\n  margin-top: var(--ds-space-5);\n}\n\n.milestone-doc .milestone-doc__toolbar {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.milestone-doc .milestone-doc__file {\n  max-height: 400px;\n  max-width: 100%;\n  margin-top: var(--ds-space-3);\n  overflow: hidden;\n  text-align: center;\n}\n\n.milestone-doc .milestone-doc__file img,\n.milestone-doc .milestone-doc__file video,\n.milestone-doc .milestone-doc__file iframe {\n  max-width: 100%;\n}\n\n.milestone-doc .milestone-doc__message {\n  margin: var(--ds-space-2) 0;\n  overflow-wrap: anywhere;\n}\n\n.milestone-doc .milestone-doc__comment {\n  width: 100%;\n  margin-top: var(--ds-space-4);\n}\n\n@media (max-width: 575.98px) {\n  .milestone-docs .milestone-docs__composer > .ant-btn {\n    flex: 1 1 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
